export default __webpack_public_path__ + "static/media/Icon-folder.5d3cd5fc.svg";